module.exports = __webpack_public_path__ + "img/Frage3_1024x768.d4cd1fc7.jpg";